"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alpha = alpha;
function alpha(hexColor, alphaPercentage) {
  // Ensure alphaPercentage is between 0 and 100
  const normalizedPercentage = Math.max(0, Math.min(100, alphaPercentage));
  // Convert percentage to hex (0-255)
  const opacity = Math.round(normalizedPercentage * 2.55);
  // Convert to hex and ensure 2 characters
  const hexOpacity = opacity.toString(16).padStart(2, '0');
  return hexColor + hexOpacity.toUpperCase();
}